import React from 'react';
import { routes } from 'routes/routes';
import { Separator } from '@/components/ui/separator';

interface PublicFooterProps {
  className?: string;
  privacyPolicyUrl?: string;
  termsConditionsUrl?: string;
  contactUrl?: string;
}

export const PublicFooter: React.FC<PublicFooterProps> = ({
  className = '',
  privacyPolicyUrl = routes.PRIVACY_POLICY,
  termsConditionsUrl = routes.TERMS_CONDITIONS,
  contactUrl = routes.CONTACT_US,
}) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`tw-bg-white tw-mt-auto ${className}`}>
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 tw-py-6">
        {/* Mobile Layout - Stacked */}
        <div className="tw-flex tw-flex-col tw-items-center tw-space-y-4 sm:tw-hidden">
          <div className="tw-text-sm tw-text-slate-600 tw-text-center">
            © {currentYear} Superb Intelligence Inc. All Rights Reserved
          </div>
          <div className="tw-flex tw-items-center tw-space-x-4 tw-text-sm">
            <a
              href={privacyPolicyUrl}
              target="_blank"
              rel="noreferrer"
              className="tw-text-foreground hover:tw-text-foreground/80 tw-transition-colors"
            >
              Privacy Policy
            </a>
            <a
              href={termsConditionsUrl}
              target="_blank"
              rel="noreferrer"
              className="tw-text-foreground hover:tw-text-foreground/80 tw-transition-colors"
            >
              Terms &amp; Conditions
            </a>
          </div>
        </div>

        {/* Desktop Layout - Inline with separators */}
        <div className="tw-hidden sm:tw-flex tw-items-center tw-justify-center tw-space-x-4 tw-text-sm tw-text-slate-600">
          <span>
            © {currentYear} Superb Intelligence Inc. All Rights Reserved
          </span>
          <Separator orientation="vertical" className="tw-h-4" />
          <a
            href={privacyPolicyUrl}
            target="_blank"
            rel="noreferrer"
            className="tw-text-foreground hover:tw-text-foreground/80 tw-transition-colors"
          >
            Privacy Policy
          </a>
          <Separator orientation="vertical" className="tw-h-4" />
          <a
            href={termsConditionsUrl}
            target="_blank"
            rel="noreferrer"
            className="tw-text-foreground hover:tw-text-foreground/80 tw-transition-colors"
          >
            Terms &amp; Conditions
          </a>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
